// extracted by mini-css-extract-plugin
export default {"addToCartControl":"T8-z","giftCard":"U8-z","btnContainer":"V8-z","cartButton":"W8-z","disabled":"X8-z","stockMessage":"Y8-z"};